'use client';

import classNames from '@sindresorhus/class-names';
import {HeaderProps} from '@ui-kit/src/Header/Header.types';
import {headerTestId} from '@ui-kit/src/Header/headerTestid';

import styles from './Anchors.module.scss';

type Props = Pick<HeaderProps, 'anchorLinks' | 'onAnchorLinkClick'>;
export const Anchors = ({anchorLinks, onAnchorLinkClick}: Props) => {
  if (!anchorLinks?.length) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.links}>
        {anchorLinks.map(({isActiveAnchor, ...link}) => (
          <a
            onClick={() => onAnchorLinkClick?.(link)}
            className={classNames(styles.link, {
              [styles.isActive]: isActiveAnchor,
            })}
            {...link}
            key={link.title}
            data-testid={headerTestId.anchor}
          >
            {link.title}
          </a>
        ))}
      </div>
    </div>
  );
};
